import { Select } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { SelectProps } from 'antd/lib'
import { TimePeriodOptions } from '../../../../../../../redux/context/customReports/types'

const TimePeriodOptionSelect = (props: SelectProps) => {
  const { t } = useTranslation()

  const options = Object.values(TimePeriodOptions)
    .sort((a, b) => t(`customReportPage:${a}`).localeCompare(t(`customReportPage:${b}`)))
    .map(timePeriodOption => {
      return { value: timePeriodOption, label: t(`customReportPage:${timePeriodOption}`) }
    })

  return (
    <Select
      options={options}
      showSearch
      optionFilterProp="label"
      style={{ width: 200 }}
      dropdownStyle={{ width: 300 }}
      {...props}
    />
  )
}

export default TimePeriodOptionSelect
